var Component         = require("enyo/Component"),
    PhotoPrintService = require("app/Domain/Ott/Api/V2/DataAccess/PhotoPrint/Service"),
    DataTransformer   = require("./DataTransformer"),
    kind              = require("enyo/kind"),
    logger            = require("enyo/logger");

module.exports = kind(/** @lends  app.Fotocadeau.FotocadeauService.prototype */ {

    /**
     * @private
     */
    name: "app.Fotocadeau.FotocadeauService",

    /**
     * @private
     */
    kind: Component,

    /**
     * Adds a new bookmark. If API replies with a success response, the cache
     * gets refreshed.
     *
     * @param    {string}   media  The media item.
     * @returns  {Promise}  A Promise that resolves with the API response
     * @public
     */
    requestPrint: function(media) {
        var $analyticsService = this.app.$.analyticsService;

        return PhotoPrintService.requestPrint(media.id)
            .then(function(response) {
                var printSession;

                if (response.status === "ok") {
                    printSession = DataTransformer.transformPrintSession(response.data);
                    $analyticsService.sendEvent(
                        ["accepted", "analyticsCookies"],
                        "Buy Product",
                        "fotocadeau_print",
                        media.type + "/" + media.meta.slug,
                        null,
                        {
                            language:  media.meta.language,
                            mediaItem: media.type + "/" + media.meta.slug
                        }
                    );

                    return Promise.resolve({
                        status:   "ok",
                        media_id: media.id,
                        data:     printSession
                    });
                }
                else {
                    return Promise.resolve({
                        status:   "error",
                        media_id: media.id,
                        type:     response.type || "unknown_error"
                    });
                }
            })

            // Could not add bookmark
            .catch(function(error) {
                logger.error(error);

                if (typeof Sentry !== "undefined" && error instanceof Error) {
                    Sentry.captureException(error);
                }

                return Promise.resolve({
                    status:   "error",
                    media_id: media.id,
                    type:     error.message || "unknown_error"
                });
            });
    }

});
